import * as React from 'react'

import { Text } from 'main/ui'
import { Container, StyledTitle } from './GenericError.styles'

const HEADING = 'Sorry, something unexpected happened.'
const BODY = 'Please try again. If the problem persists, contact hello@wonderschool.com.'

function GenericError({ heading = HEADING }) {
  return (
    <Container>
      <StyledTitle kind="normal">{heading}</StyledTitle>
      <Text>{BODY}</Text>
    </Container>
  )
}

export default React.memo(GenericError)
